import { ReactNode } from 'react';

export const NOTIFICATION_QUERY_PARAM = 'notification';

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
}

export enum NotificationMode {
  FLASH = 'flash',
  TOAST = 'toast',
}

export type NotificationItem = {
  id: string;
  message: string | ReactNode;
  type: NotificationType;
  mode: NotificationMode;
  description?: string;
  isClosable?: boolean;
};

export type NotificationListProps = {
  data: Array<NotificationItem>;
};
